import { BaseKb3dModel } from '../decorators/kb3d-decorator';
import { IMaterialMapping } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';

@BaseKb3dModel({
    token: Token.MaterialMapping,
})
export abstract class MaterialMapping extends Kb3dObject implements IMaterialMapping {
    uOffset = 0; // Define an offset on the texture to offset the u coordinates of the UVs
    vOffset = 0; // Define an offset on the texture to offset the v coordinates of the UVs
    uScale = 1; // Define an offset on the texture to scale the u coordinates of the UVs
    vScale = 1; // Define an offset on the texture to scale the v coordinates of the UVs
    uAngle = 0; // Define an offset on the texture to rotate around the u coordinates of the UVs
    vAngle = 0; // Define an offset on the texture to rotate around the v coordinates of the UVs
    wAngle = 0; // Define an offset on the texture to rotate around the w coordinates of the UVs
    uPivot = 0.5; // Defines the center of rotation (U)
    vPivot = 0.5; // Defines the center of rotation (V)
    wPivot = 0.5; // Defines the center of rotation (W)
}
